var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LayoutNavBtn"},[_c('div',{class:("LayoutNavBtn-container " + _vm.active)},[_c('span'),_c('span'),_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }